import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = signal(false);
  readonly loading = this._loading.asReadonly();

  show() {
    this._loading.set(true);
  }
  hide() {
    this._loading.set(false);
  }

  // wrap() = “Turn on the spinner, run the async task, and turn it off when done — no matter what happens.”
  async wrap<T>(promise: Promise<T>): Promise<T> {
    this.show();

    try {
      return await promise;
    } finally {
      this.hide();
    }
  }
}
